// src/config.js
//
// Single source of truth for the backend API URL. Every page/component
// imports API_BASE from here instead of hardcoding it - so when you
// deploy, you only need to change ONE place (an environment variable),
// not 10 different files.
//
// LOCAL DEVELOPMENT: uses http://localhost:5000/api automatically
// (no setup needed - this is the default fallback below).
//
// PRODUCTION (Netlify): set an environment variable named
// REACT_APP_API_BASE to your real Render backend URL, e.g.
//   REACT_APP_API_BASE=https://nfxseller-backend.onrender.com/api
//
// IMPORTANT: any environment variable used by Create React App MUST
// start with REACT_APP_ or it gets silently ignored - this is a CRA
// rule, not something we chose.

export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000/api';
